var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.25C22 9.86726 19.2577 7.125 15.875 7.125C12.4923 7.125 9.75 9.86726 9.75 13.25",
    stroke: "#29C88B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.25C21.9836 15.2327 21.491 16.1827 19.8125 17.625V22.875H12.8125V21.5625C12.8125 21.5625 11.5 21.5625 10.625 21.5625C9.75 21.5625 9.3125 21.125 9.3125 20.25C9.3125 19.375 9.3125 18.0625 9.3125 18.0625H8L9.75 14.5625V13.25",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 13.25C19.375 11.317 17.808 9.75 15.875 9.75",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/Mind.2d8f2220c2ca7c47aa556690b9ed27af.svg";
export { ForwardRef as ReactComponent };